import { Link } from "react-router-dom";
import { SignIn } from "@clerk/clerk-react";
import Logo from "@/components/Logo";
import { clerkAppearance } from "@/lib/clerkAppearance";

export default function Login() {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left brand */}
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-40" />
        <Link to="/" className="flex items-center gap-2 relative z-10">
          <Logo to={null} dark iconSize={36} />
        </Link>
        <div className="relative z-10">
          <p className="text-sky-400 text-sm font-semibold mb-3 uppercase tracking-wide">Revenue Engine & Sales Automation Driven by AI</p>
          <h2 className="font-display text-4xl font-extrabold leading-tight">
            Cari ribuan leads bisnis dalam <span className="text-sky-400">hitungan detik.</span>
          </h2>
          <p className="text-slate-300 mt-4 max-w-md">
            Scrape Google Maps, kelola lead, dan blast WhatsApp dari satu dashboard. Hemat 90% waktu prospekmu.
          </p>
        </div>
        <p className="text-slate-500 text-sm relative z-10">© 2026 RESADA</p>
      </div>

      {/* Right: Clerk Sign In */}
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm animate-float-up" data-testid="clerk-signin">
          <div className="lg:hidden mb-8">
            <Logo to="/" iconSize={34} />
          </div>
          <SignIn
            routing="hash"
            signUpUrl="/register"
            forceRedirectUrl="/app"
            fallbackRedirectUrl="/app"
            appearance={clerkAppearance}
          />
        </div>
      </div>
    </div>
  );
}
